import React from "react";
import styled from "@emotion/styled";
import { Colors } from "./colors";
import { mobileWidth } from "./constants";
import { useTranslation } from 'react-i18next';

const Featurebar = () => {
  const { t, i18n } = useTranslation();
  return (
          <FeatureCardContainer className="col-lg-12">
            <FeatureCard>
              <FeatureIcon
                src="../../static/images/social-media.gif"
                alt="Info Shield"
              />
              <FeatureHeader>{t("main_privacy")}</FeatureHeader>
              <FeatureDescription>
                {t("main_privacy_details")}
              </FeatureDescription>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon src="../../static/images/target.gif" alt="Free" />
              <FeatureHeader>{t("main_precision")}</FeatureHeader>
              <FeatureDescription>
                {t("main_precision_details")}
              </FeatureDescription>
            </FeatureCard>
            <FeatureCard>
              <FeatureIcon
                src="../../static/images/line-chart.gif"
                alt="Handshake"
              />
              <FeatureHeader>{t("main_no_cost")}</FeatureHeader>
              <FeatureDescription>
                {t("main_no_cost_details")}
              </FeatureDescription>
            </FeatureCard>
          </FeatureCardContainer>
  );
};

export default Featurebar;

const FeatureCardContainer = styled.div`
  background-color: #ffffff;
  padding: 40px;
  display: flex;
  margin: 15px 0;
  justify-content: space-between;
  @media (max-width: ${mobileWidth}){
    flex-direction:column;
  }
`;

const FeatureCard = styled.div`
  flex: 0 0 calc(33.33% - 30px); /* 30px is the total horizontal padding */
  margin-bottom: 30px; /* Add some space between cards */
  padding: 15px;
  text-align: center;
`;

const FeatureIcon = styled.img`
  margin-bottom: -15px;
  width: 50px; /* Set the width to match other icons */
  height: 50px; /* Set the height to match other icons */
`;

const FeatureHeader = styled.h4`
  font-weight: 500;
  margin-top: 30px;
`;

const FeatureDescription = styled.p`
  font-weight: 300;
`;
